import { MemberStatus } from "@/types/schema"

// Authentication result type
export interface AuthResult {
  success: boolean
  message?: string
  error?: string
  user?: any
}

// Invitation data type
export interface InviteData {
  email: string
  firstName?: string
  lastName?: string
  phone?: string // Added phone field
  role?: string
  portfolioId?: string
  permissions?: any[]
  invitedAt: string
  createdAt?: any
  status?: MemberStatus
}

// Email verification action code settings
export const actionCodeSettings = {
  url: `${window.location.origin}/account/verify-email`,
  handleCodeInApp: true,
}
